import React from 'react'
import Errors from '../errors'

const ErrorsNl = () => {
    return <Errors languageCode="nl" />
}

export default ErrorsNl
